import {gsap} from 'gsap'
import Swiper from 'swiper'
import {Navigation, EffectFade, Pagination} from 'swiper/modules'
import {timelineSwiper} from './timeline-years'

const initializeTimelineTextSliders = () => {
  const tlTextSwipers = document.querySelectorAll('.timeline-text-slider');

  tlTextSwipers.forEach(tlSwiper => {
    const swiper = tlSwiper.querySelector('.swiper-timeline-text-slider');
    const slideNext = tlSwiper.querySelector('.slide-next');
    const slidePrev = tlSwiper.querySelector('.slide-prev');
    const paginationEl = tlSwiper.querySelector('.timeline-text-slide-pagination');
    const text = tlSwiper.querySelectorAll('.swiper-timeline-text');
    const timelineWrapper = document.querySelector('.timeline-dots');
    const timelineDots = timelineWrapper.querySelectorAll('.timeline-dot');
    let initialLoadComplete = false;

    const updateActiveDot = (activeIndex) => {
      timelineDots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      timelineSwiper.slideTo(activeIndex);
    };

    let tlTextSwiperInstance = new Swiper(swiper, {
      modules: [Navigation, EffectFade, Pagination],
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: slideNext,
        prevEl: slidePrev,
      },
      pagination: {
        el: paginationEl,
        type: 'fraction',
      },
      on: {
        beforeInit: function () {
          const slides = tlSwiper.querySelectorAll('.swiper-slide');
          slides.forEach(slide => {
            if (!slide.innerHTML.trim()) {
              slide.classList.add('empty-slide');
            }
          });
        },
        slideChange: function () {
          if (initialLoadComplete) {
            gsap.fromTo(text, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.8 });
          }
          updateActiveDot(this.realIndex % timelineDots.length);
        },
        init: function () {
         initialLoadComplete = true;
        }
      }
    });

    timelineDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        tlTextSwiperInstance.slideToLoop(index);
        updateActiveDot(index);
      });
    });
  });
};

initializeTimelineTextSliders();

